// @flow

import React from 'react';
import { Alert, Card, CardBody, CardHeader, Table } from 'reactstrap';
import StyleClasses from '../../styles/StyleClasses';

type PropsType = {
    organization: {
        record: {
            digital_fee_bps?: ?number,
            processor_fee_bps_estimate?: ?number,
            payfacto_rev_share_bps?: ?number,
            premium_feature_fee?: ?number,
            premium_feature_label?: ?string,
        },
    },
};

function formatBps(value: ?number): string {
    if (value === null || value === undefined) {
        return 'Not configured';
    }

    return `${value} bps (${(value / 100).toFixed(2)}%)`;
}

function formatMoney(value: ?number): string {
    if (value === null || value === undefined) {
        return 'Not configured';
    }

    return new Intl.NumberFormat('en-CA', {
        style: 'currency',
        currency: 'CAD',
    }).format(value / 100);
}

export default function OrganizationCommercialTermsPanel({ organization }: PropsType) {
    const record = organization.record || {};
    const hasConfiguredTerms = [
        record.digital_fee_bps,
        record.processor_fee_bps_estimate,
        record.payfacto_rev_share_bps,
        record.premium_feature_fee,
        record.premium_feature_label,
    ].some((value) => value !== null && value !== undefined && value !== '' && value !== 0);

    return (
        <div className={StyleClasses.spacedElement}>
            <Card>
                <CardHeader>Partner Commercial Terms</CardHeader>
                <CardBody>
                    <Alert color={hasConfiguredTerms ? 'info' : 'warning'} className={StyleClasses.elementWithSharpCorners}>
                        {hasConfiguredTerms
                            ? 'These terms drive the estimate-grade fee and payout calculations shown on the partner Fees & Settlements page.'
                            : 'No partner commercial terms are configured yet. The partner portal will show finance activity, but fee estimates will remain at zero until these values are set.'}
                    </Alert>
                    <Table responsive size="sm" className="mb-0">
                        <tbody>
                            <tr>
                                <td className="w-25">Digital fee</td>
                                <td>{formatBps(record.digital_fee_bps)}</td>
                            </tr>
                            <tr>
                                <td>Processor fee estimate</td>
                                <td>{formatBps(record.processor_fee_bps_estimate)}</td>
                            </tr>
                            <tr>
                                <td>PayFacto rev share</td>
                                <td>{formatBps(record.payfacto_rev_share_bps)}</td>
                            </tr>
                            <tr>
                                <td>Premium feature label</td>
                                <td>{record.premium_feature_label || 'Not configured'}</td>
                            </tr>
                            <tr>
                                <td>Premium feature fee</td>
                                <td>{formatMoney(record.premium_feature_fee)}</td>
                            </tr>
                        </tbody>
                    </Table>
                </CardBody>
            </Card>
        </div>
    );
}